import { useEffect } from 'react';
import { getLocaleStore } from '@/i18n';
import type { IFramework } from '../../framework';

/** Shift+1 画布显示全部（无边画布） */
export function useShowAllHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        framework.service.hotkey.register({
            name: $t((v) => v.Text_CanvasShowAll),
            win: 'Shift 1',
            mac: '⇧ 1',
            key: 'show-all',
            processors: [
                {
                    press: ['Shift+1'],
                    fn: () => {
                        if (framework.service.edgelessCanvas.isEdgelessMode) {
                            framework.service.edgelessCanvas.showAllObjects();
                        }
                    },
                },
            ],
        });
    }, []);
}
